import { Component, OnInit, ChangeDetectionStrategy, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Settings } from '@common/core/config/settings.service';
import { AppHttpClient } from '@common/core/http/app-http-client.service';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'payment-success',
  templateUrl: './payment-success.component.html',
  styleUrls: ['./payment-success.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PaymentSuccess implements OnInit {

  public paymentDetail$ = new BehaviorSubject<any>(null);
  public loading$ = new BehaviorSubject<boolean>(true);

  get paymentDetail() {
    return this.paymentDetail$.value;
  }

  constructor(
    private route: ActivatedRoute,
    private http: AppHttpClient,
    public settings: Settings
  ) {}

  ngOnInit(): void {

    this.route.params.subscribe(params => {

      this.http.get(`chargebee/${params.id}/payment-success`)
          .subscribe(response => {
            console.log(response);

            this.loading$.next(false);
            this.paymentDetail$.next(response);

          }, error => {
            console.log(error);
          })
    })
  }

}
